import React from 'react';
import styled from 'styled-components';

const Top = styled.div`
  height: 18px;
  width: 52px;
  background-image: url('img/gateway/top-right.png');
  background-size: cover;
  background-repeat: no-repeat;
  display: flex;
`;

const Pole = styled.div`
  height: calc(100% - 18px - 30px);
  width: 52px;
  background-image: url('img/gateway/right.png');
  background-repeat: repeat;
  background-size: contain;
  display: flex;
`;

const Bottom = styled.div`
  height: 30px;
  width: 52px;
  background-image: url('img/gateway/bottom-right.png');
  background-size: cover;
  display: flex;
`;

const Container = styled.div`
    display: flex;
    flex-direction: column;
    height: calc(100% + 14px);
`;

const RightPole = () => (
  <Container>
    <Top />
    <Pole />
    <Bottom />
  </Container>
);

export default RightPole;
